
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { ModuleItemProps } from ".";
import { loading, endLoading } from "store/module";

interface ApiModuleRemoveInputProps {
    ids: number[]
}

type ApiModuleRemoveOutputProps = OutputBaseProps<{ item: ModuleItemProps; }>

export const apiModuleRemove = async (data: ApiModuleRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiModuleRemoveOutputProps>("/api/module/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};